export const MM_TO_INCH = 25.4;

export const convertToInch = (milimeter: number): number => milimeter / MM_TO_INCH;

export const convertToMilimeter = (inch: number): number => inch * MM_TO_INCH;
